import modules from "@/app.default"
import { BooleanInput, Edit, SelectInput, SimpleForm } from "@/components/admin"
import { ReactElement } from "react"
const UserEdit = (): ReactElement => {
  return (
    <Edit title={null}>
      <SimpleForm>
        <SelectInput
          source="action"
          choices={[
            { id: "list", name: "Lister" },
            { id: "show", name: "Afficher" },
            { id: "edit", name: "Éditer" },
            { id: "create", name: "Créer" },
            { id: "show", name: "Afficher" },
          ]}
        />
        <SelectInput source="resource" choices={Object.keys(modules)} />
        <BooleanInput source="allowed" />
      </SimpleForm>
    </Edit>
  )
}

export default UserEdit
